import { render, staticRenderFns } from "./ReviewsAmenitiesMobile.vue?vue&type=template&id=3f202298&"
import script from "./ReviewsAmenitiesMobile.vue?vue&type=script&lang=js&"
export * from "./ReviewsAmenitiesMobile.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAmenitiesMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports